// Split out of index.js: ChangePassword.jsx needs these, and index.js imports
// ChangePassword.jsx, which made them a circular import.
// ACTION_REQUEST: send verification code via email
// ACTION_CHANGE: change password, with either old password or verification code
export const ACTION_REQUEST = "request-link";
export const ACTION_CHANGE = "change-password";
